import BaseSetup from '@/components/BaseSetup';
import useAuthService from '@/services/AuthService';
import { Reactive } from '@/utils/decorators';
import { useNotif } from '@orion.ui/orion';
import { } from 'vue';

export type ModalConfirmPasswordEmits = {};
export type ModalConfirmPasswordProps = {
	resolve?: (value: boolean) => void
};

export default class ModalConfirmPasswordSetup extends BaseSetup {

	static readonly defaultProps = {};

	@Reactive private readonly state = { password: undefined as Undef<string> };

	get password () { return this.state.password }
	set password (val) { this.state.password = val }

	constructor (
		private props: ModalConfirmPasswordProps,
		private emits: ModalConfirmPasswordEmits,
		private _modal?: OrionModal,
	) {
		super();
	}

	cancel () {
		if (this.props.resolve)
			this.props.resolve(false);
		this._modal?.close();
	}

	private checkPasswordLength = () => !!this.password?.trim()?.length;

	async validateAsync () {
		if (!this.checkPasswordLength()) return;

		this._modal?._loader()?.show(this.$t('common.password.verifying'));

		const data = await useAuthService().confirmPasswordAsync({
			userId: this.self.id,
			password: this.password,
		});

		if (data) {
			this._modal?.close();
			if (this.props.resolve) {
				this.props.resolve(data);
			}
		}
		else {
			this._modal?._loader()?.hide();
			useNotif.warning(this.$t('common.notification.oops'), this.$t('business.apiErrors.oops'));
		}
	}

}
